export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export function addError(error) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      return resolve(dispatch({
        type: ADD_ERROR,
        error: true,
        payload: typeof error === 'string' ? error : `Oppss..the server encountered an error and could not complete your request. Please clear your cache and try again, or proceed with Incognito Mode/Private Browsing mode. 
If problem persists, send your shopping list to support@helprnow.com and we will revert within 1 working day! :)`
      }));
    });
  };
}

export function resetError() {
  return {
    type: RESET_ERROR_MESSAGE,
    error: false
  };
}